export default function() {
  return {
    namespaced: true,
    state: {
      session: 0,
      total: 0,
      done: 0,
    },
    mutations: {
      START(state, { total, session }) {
        state.session = session;
        state.total = total;
        state.done = 0;
      },
      DONE(state, { session }) {
        if (state.session == session) {
          state.done += 1;
        }
      }
    },
    actions: {
      START({ state, commit }, { total = 0, session }) {
        commit('START', {total, session});
      },
      DONE({ state, commit }, { session }) {
        commit('DONE', { session });
      }
    }
  }
}